import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import RBIDropdownSelector from './RBIDropdownSelector';
import { useTranslation } from 'react-i18next';

export function AvailabilitySelector({
  name,
  regions,
  region,
  handleChangeSelectRegion,
  countries,
  country,
  handleChangeSelectCountry,
  handleChangeSelectState,
  state,
  states,
  isAllDisabled = false,
}) {
  const { t } = useTranslation();
  return (
    <>
      <Grid item xs={12}>
        <Typography>{name}</Typography>
      </Grid>
      <Grid item xs={4}>
        <RBIDropdownSelector
          name={t('productGroup.holdingProfile.availabilityRegion')}
          options={regions}
          selected={region}
          extraOption={t(
            'productGroup.holdingProfile.availability.extraOption.global',
          )}
          extraOptionValue={'all'}
          handleChangeSelect={handleChangeSelectRegion}
          isDisabled={isAllDisabled}
        />
      </Grid>
      <Grid item xs={4}>
        <RBIDropdownSelector
          name={t('productGroup.holdingProfile.availabilityCountry')}
          options={countries}
          selected={country}
          handleChangeSelect={handleChangeSelectCountry}
          extraOption={t(
            'productGroup.holdingProfile.availability.extraOption.all',
          )}
          extraOptionValue={'all'}
          isDisabled={isAllDisabled}
        />
      </Grid>
      <Grid item xs={4}>
        <RBIDropdownSelector
          name={t('productGroup.holdingProfile.availabilityState')}
          options={states}
          selected={state}
          handleChangeSelect={handleChangeSelectState}
          extraOption={t(
            'productGroup.holdingProfile.availability.extraOption.all',
          )}
          isDisabled={isAllDisabled}
          extraOptionValue={'all'}
        />
      </Grid>
      <Grid item xs={12} style={{ marginBottom: 15 }}>
        <Divider />
      </Grid>
    </>
  );
}
